import script from "./TextWithHint.vue?vue&type=script&setup=true&lang=js"
export * from "./TextWithHint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HelpHint from "@/components/neue/wizard/HelpHint.vue";
script.components = Object.assign({}, { HelpHint }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HelpHint }, script.__o.components);}